﻿import { Switch, useTheme } from 'shared-ui';
import { Moon } from 'lucide-react';
import { OrbitSidebarMenuButton } from '@/components/app/OrbitSidebarMenuButton.tsx';

export function SidebarThemeToggle() {
    const { resolvedMode, setMode } = useTheme();

    return (
        <OrbitSidebarMenuButton
            tooltip="Toggle Mode"
            onClick={() => {
                setMode(resolvedMode === 'dark' ? 'light' : 'dark');
            }}
        >
            <OrbitSidebarMenuButton.Icon icon={Moon} />
            <span className="flex-1 text-sm font-semibold">Dark Mode</span>
            <Switch
                className="ml-auto group-data-[collapsible=icon]:hidden"
                checked={resolvedMode === 'dark'}
                onCheckedChange={(checked) => {
                    setMode(checked ? 'dark' : 'light');
                }}
            />
        </OrbitSidebarMenuButton>
    );
}
